/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Tier-pricing pill — single-open accordion toggle.
  // Plain show/hide via data-open attribute; intentionally not using the theme's
  // collapsible-elements custom element (its translateY + opacity transition
  // caused jitter against the card background on this layout).
  // Delegated to document so it picks up pills rendered after initial load
  // (e.g. variant re-renders that re-inject the PDP block).
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-tier-pill-trigger]');
    if (!trigger) return;
    e.preventDefault();
    var item = trigger.closest('[data-tier-pill-item]');
    if (!item) return;
    var card = item.parentElement; // .tier-pill
    var wasOpen = item.getAttribute('data-open') === 'true';
    // Close all sibling items in the same card (single-open behaviour)
    var siblings = card.querySelectorAll('[data-tier-pill-item]');
    for (var i = 0; i < siblings.length; i++) {
      siblings[i].setAttribute('data-open', 'false');
      var sibTrigger = siblings[i].querySelector('[data-tier-pill-trigger]');
      if (sibTrigger) sibTrigger.setAttribute('aria-expanded', 'false');
    }
    if (!wasOpen) {
      item.setAttribute('data-open', 'true');
      trigger.setAttribute('aria-expanded', 'true');
    }
  });


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


// Afterpay styles and content manipulation
(function () {
  function applyAfterpayStyles() {
    const placement = document.querySelector('square-placement');
    if (!placement || !placement.shadowRoot) return;

    const shadow = placement.shadowRoot;

    // Prevent duplicate injection
    if (!shadow.querySelector('#afterpay-custom-style')) {
      const style = document.createElement('style');
      style.id = 'afterpay-custom-style';
      style.textContent = `
        .afterpay-paragraph {
          line-height: 1.5;
        }
        .afterpay-paragraph {
          --messaging-font-size: 15.12px;
        }
        .afterpay-logo.brand-afterpay {
          --logo-badge-width: 82px;
          vertical-align: middle;
        }

        @media (max-width: 1000px) {
          .afterpay-main-text {
            display: block;
            line-height: 1;
          }
        }

        @media (max-width: 480px) {
          .afterpay-logo.brand-afterpay {
            --logo-badge-width: 72px;
          }
          .afterpay-main-text {
              font-size: 13px;
              display: inline;
          }
        }
         
      `;
      shadow.appendChild(style);
    }

    // Rewrite copy to: "4 x $XX.XX with "
    const text = shadow.querySelector('.afterpay-main-text');
    if (text && !text.dataset.modified) {
      const amount = text.querySelector('strong')?.textContent?.trim();
      if (amount) {
        text.textContent = `4 x ${amount} with `;
        text.dataset.modified = 'true';
      }
    }
  }

  // Initial run
  applyAfterpayStyles();

  // Observe re-renders (Afterpay + Shopify)
  const observer = new MutationObserver(applyAfterpayStyles);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

// PDP selected color media filter:
// Shows only gallery media whose filename or alt text matches the selected color option.
(function () {
  const selectors = {
    productInfo: 'product-info[data-filter-media-by-color="true"]',
    slide: '[data-product-single-media-wrapper]',
    slider: '[data-product-single-media-slider]',
    thumbnails: '[data-product-single-media-thumbs]',
    thumbnail: '.product-single__thumbnail',
    selectedVariant: 'variant-selects [data-selected-variant]',
  };

  const classes = {
    hiddenSlide: 'product-gallery__media-slide--color-hidden',
    hiddenThumbnail: 'product-single__thumbnail--color-hidden',
  };

  const productMediaState = new WeakMap();

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/%20/g, ' ')
      .replace(/[^a-z0-9]+/g, '');
  }

  function getCurrentVariant(productInfo) {
    const variantScript = productInfo.querySelector(selectors.selectedVariant);
    if (!variantScript?.textContent) return null;

    try {
      return JSON.parse(variantScript.textContent);
    } catch (error) {
      return null;
    }
  }

  function getColorOptionIndex(productInfo) {
    const colorInput = productInfo.querySelector('input[name^="options["][name*="Color" i], input[name^="options["][name*="Colour" i], select[name^="options["][name*="Color" i], select[name^="options["][name*="Colour" i]');
    const optionName = colorInput?.getAttribute('name') || '';
    const optionLabel = optionName.match(/options\[(.+)\]/)?.[1] || '';
    const optionInputs = Array.from(productInfo.querySelectorAll('[name^="options["]'));
    const optionNames = [...new Set(optionInputs.map((input) => input.getAttribute('name')).filter(Boolean))];
    const optionIndex = optionNames.findIndex((name) => name.includes(`[${optionLabel}]`));

    return optionIndex >= 0 ? optionIndex : -1;
  }

  function getSelectedColor(productInfo) {
    const colorInput = productInfo.querySelector('input[name^="options["][name*="Color" i]:checked, input[name^="options["][name*="Colour" i]:checked');
    if (colorInput?.value) return colorInput.value;

    const colorSelect = productInfo.querySelector('select[name^="options["][name*="Color" i], select[name^="options["][name*="Colour" i]');
    if (colorSelect?.value) return colorSelect.value;

    const currentVariant = getCurrentVariant(productInfo);
    const colorIndex = getColorOptionIndex(productInfo);

    return colorIndex >= 0 ? currentVariant?.options?.[colorIndex] : '';
  }

  function getSlideImage(slide) {
    return slide.querySelector('img[data-product-image], img');
  }

  function slideMatchesColor(slide, colorKey) {
    const image = getSlideImage(slide);
    if (!image) return false;

    const sourceText = normalize([image.currentSrc, image.src, image.getAttribute('src'), image.getAttribute('srcset')].filter(Boolean).join(' '));
    if (sourceText.includes(colorKey)) return true;

    return normalize(image.getAttribute('alt')).includes(colorKey);
  }

  function syncThumbnails(productInfo, visibleMediaIds) {
    productInfo.querySelectorAll(selectors.thumbnail).forEach((thumbnail) => {
      const mediaId = thumbnail.dataset.id;
      const shouldShow = !mediaId || visibleMediaIds.has(mediaId);

      thumbnail.classList.toggle(classes.hiddenThumbnail, !shouldShow);
    });
  }

  function getProductMediaState(productInfo) {
    if (!productMediaState.has(productInfo)) {
      productMediaState.set(productInfo, {
        slider: productInfo.querySelector(selectors.slider),
        thumbnails: productInfo.querySelector(selectors.thumbnails),
        slides: Array.from(productInfo.querySelectorAll(selectors.slide)),
        thumbnailItems: Array.from(productInfo.querySelectorAll(selectors.thumbnail)),
      });
    }

    return productMediaState.get(productInfo);
  }

  function restoreProductMedia(productInfo) {
    const state = getProductMediaState(productInfo);
    const { flkty, flktyNav } = getFlickityInstances(state);
    const slideContainer = flkty?.isActive ? flkty.slider : state.slider;
    const thumbnailContainer = flktyNav?.isActive ? flktyNav.slider : state.thumbnails;

    state.slides.forEach((slide) => {
      slide.classList.remove(classes.hiddenSlide);
      slideContainer?.appendChild(slide);
    });

    state.thumbnailItems.forEach((thumbnail) => {
      thumbnail.classList.remove(classes.hiddenThumbnail);
      thumbnailContainer?.appendChild(thumbnail);
    });

    return state;
  }

  function getFlickityInstances(state) {
    return {
      flkty: state.slider ? window.theme?.Flickity?.data(state.slider) : null,
      flktyNav: state.thumbnails ? window.theme?.Flickity?.data(state.thumbnails) : null,
    };
  }

  function refreshFlickity(productInfo, state, firstVisibleSlide) {
    const { flkty, flktyNav } = getFlickityInstances(state);
    const slideContainer = flkty?.isActive ? flkty.slider : state.slider;
    const visibleSlides = Array.from(slideContainer?.children || []);
    const firstVisibleIndex = firstVisibleSlide ? visibleSlides.indexOf(firstVisibleSlide) : -1;

    [flkty, flktyNav].forEach((instance) => {
      if (!instance?.isActive) return;

      instance.reloadCells?.();
      instance.resize?.();

      if (firstVisibleIndex >= 0) {
        instance.select(firstVisibleIndex, false, true);
      }
    });

    if (flkty?.isActive && firstVisibleSlide?.dataset.mediaId && typeof productInfo.switchMedia === 'function') {
      productInfo.switchMedia(firstVisibleSlide.dataset.mediaId);
    }
  }

  function filterStaticMedia(productInfo, state, visibleSlides) {
    const visibleMediaIds = new Set();

    state.slides.forEach((slide) => {
      const shouldShow = visibleSlides.includes(slide);
      slide.removeAttribute('style');
      slide.classList.toggle(classes.hiddenSlide, !shouldShow);

      if (shouldShow && slide.dataset.id) {
        visibleMediaIds.add(slide.dataset.id);
      }
    });

    syncThumbnails(productInfo, visibleMediaIds);
  }

  function filterFlickityMedia(productInfo, state, visibleSlides) {
    const visibleMediaIds = new Set(visibleSlides.map((slide) => slide.dataset.id).filter(Boolean));

    state.slides.forEach((slide) => {
      if (!visibleSlides.includes(slide)) slide.remove();
    });

    state.thumbnailItems.forEach((thumbnail) => {
      if (thumbnail.dataset.id && !visibleMediaIds.has(thumbnail.dataset.id)) {
        thumbnail.remove();
      }
    });

    refreshFlickity(productInfo, state, visibleSlides[0]);
  }

  function filterProductMedia(productInfo) {
    if (!productInfo?.matches?.(selectors.productInfo)) return;

    const state = restoreProductMedia(productInfo);
    const { flkty } = getFlickityInstances(state);
    const shouldUseFlickity = productInfo.getAttribute('data-tall-layout') !== 'true' || window.innerWidth < window.theme.sizes.large;
    const isFlickityActive = shouldUseFlickity && Boolean(flkty?.isActive);
    const colorKey = normalize(getSelectedColor(productInfo));
    const slides = state.slides;
    if (!slides.length) return;

    if (!colorKey) {
      refreshFlickity(productInfo, state, slides[0]);
      return;
    }

    const matchingSlides = slides.filter((slide) => slideMatchesColor(slide, colorKey));
    const hasMatches = matchingSlides.length > 0;
    const visibleSlides = hasMatches ? matchingSlides : slides;

    if (isFlickityActive) {
      filterFlickityMedia(productInfo, state, visibleSlides);
    } else {
      filterStaticMedia(productInfo, state, visibleSlides);
    }
  }

  function filterAllProductMedia() {
    document.querySelectorAll(selectors.productInfo).forEach((productInfo) => {
      filterProductMedia(productInfo);
    });
  }

  function scheduleFilterAllProductMedia() {
    requestAnimationFrame(() => {
      requestAnimationFrame(filterAllProductMedia);
    });
  }

  function isColorOptionTarget(target) {
    return Boolean(target?.name?.match(/options\[(Color|Colour)\]/i));
  }

  document.addEventListener('theme:product-info:loaded', (event) => {
    requestAnimationFrame(() => filterProductMedia(event.target));
  });

  document.addEventListener('DOMContentLoaded', () => {
    scheduleFilterAllProductMedia();
  });

  document.addEventListener('theme:resize:width', () => {
    scheduleFilterAllProductMedia();
  });

  // Run ahead of the theme's server-rendered variant update so PDP media changes feel instant.
  if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.optionValueSelectionChange) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
      const productInfo = data?.target?.closest?.(selectors.productInfo);
      if (!productInfo || !isColorOptionTarget(data.target)) return;

      requestAnimationFrame(() => filterProductMedia(productInfo));
    });
  }

  if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.variantChange) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const productInfo = document.querySelector(`${selectors.productInfo}[data-section="${data.sectionId}"]`);

      requestAnimationFrame(() => filterProductMedia(productInfo));
    });
  }
})();



// Palo Alto resolves preorder state server-side and re-renders the ATC button HTML on variant changes.
// Observe final button text output and synchronise preorder state + form property atomically.

(function () {
  const observed = new WeakSet();

  function extractEstimatedToShip(textNode) {
    const helper = textNode.querySelector('.button-helper-text');
    if (!helper) return '';

    const text = helper.textContent.replace(/\s+/g, ' ').trim();
    const idx = text.indexOf('Estimated to Ship');
    return idx !== -1 ? text.slice(idx) : '';
  }

  function sync(productForm) {
    const submitButton = productForm.querySelector('[type="submit"]');
    const textNode = submitButton?.querySelector('[data-add-to-cart-text]');
    if (!submitButton || !textNode) return;

    const form = submitButton.closest('form');
    if (!form) return;

    const isInventoryPreorder =
      textNode.querySelector('.button-helper-text') &&
      textNode.textContent.includes('Estimated to Ship');

    // 1. ORIGINAL behaviour (unchanged)
    submitButton.classList.toggle(
      'is_inventory_preorder',
      isInventoryPreorder
    );

    // 2. Property sync (same timing, same truth)
    const existing = form.querySelector(
      'input[name="properties[Pre-order]"]'
    );

    if (isInventoryPreorder) {
      const shipText = extractEstimatedToShip(textNode);
      if (!shipText) return; // guard against mid-render churn

      if (!existing) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Pre-order]';
        input.value = shipText;
        form.appendChild(input);
      } else {
        existing.value = shipText;
      }
    } else {
      existing?.remove();
    }
  }

  function init(productForm) {
    const submitButton = productForm.querySelector('[type="submit"]');
    const textNode = submitButton?.querySelector('[data-add-to-cart-text]');
    if (!submitButton || !textNode) return;
    if (observed.has(textNode)) return;

    const observer = new MutationObserver(() => {
      sync(productForm);
    });

    observer.observe(textNode, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    // initial run
    sync(productForm);

    observed.add(textNode);
  }

  document.querySelectorAll('product-form').forEach(init);
})();





// Pre-order acceptance modal
// turning off
// (function () {

//   let consentGiven = false;

//   function getEstimateFromButton(button) {
//     const helper = button.querySelector('.button-helper-text');
//     if (!helper) return '';

//     const text = helper.textContent.replace(/\s+/g, ' ').trim();

//     const idx = text.indexOf('Estimated to Ship');
//     return idx !== -1 ? text.slice(idx) : '';
//   }

//   function createPopup() {
//     let popup = document.getElementById('preorder-consent-popup');

//     if (!popup) {
//       popup = document.createElement('div');
//       popup.id = 'preorder-consent-popup';
//       popup.style.display = 'none';

//       popup.innerHTML = `
//         <div class="preorder-overlay"></div>
//         <div class="preorder-modal">

//           <button type="button" class="preorder-close" aria-label="Close">&times;</button>

//           <h3>Please Confirm Your Pre-Order</h3>

//           <p class="preorder-message">
//             This item is a pre-order and will not ship immediately.<br>
//             <span class="preorder-estimate"></span>            
//           </p>


//           <p>
//             <label class="preorder-checkbox">
//               <input type="checkbox" id="preorder-consent-check" />
//               <span class="custom-checkbox"></span>
//               <span class="checkbox-text">
//               I understand this is a pre-order item and it will ship on or after the estimated date above, and I agree to the <a href="https://originalfitwear.com/en-au/pages/pre-order" target="_blank" class="preorder-info-link">
//               pre-order terms
//             </a>.
//               </span>
//             </label>
//           </p>

//           <div class="preorder-buttons">

//             <button type="button"
//               class="btn btn--solid btn--small btn--black btn--advanced btn--advanced-width-height btn--bottom preorder-continue"
//               disabled>
//               <hover-button></hover-button>
//               ADD PRE-ORDER TO CART 
//             </button>

//             <button type="button"
//               class="btn btn--outline btn--small btn--black btn--advanced btn--advanced-width-height btn--bottom preorder-decline">
//               <hover-button></hover-button>
//               Cancel
//             </button>

//           </div>

//         </div>
//       `;

//       document.body.appendChild(popup);

//       const overlay = popup.querySelector('.preorder-overlay');
//       const closeBtn = popup.querySelector('.preorder-close');
//       const checkbox = popup.querySelector('#preorder-consent-check');
//       const confirmBtn = popup.querySelector('.preorder-continue');
//       const declineBtn = popup.querySelector('.preorder-decline');

//       checkbox.addEventListener('change', function () {
//         confirmBtn.disabled = !this.checked;
//       });

//       overlay.addEventListener('click', closePopup);
//       closeBtn.addEventListener('click', closePopup);
//       declineBtn.addEventListener('click', closePopup);
//     }

//     return popup;
//   }

//   function closePopup() {
//     const popup = document.getElementById('preorder-consent-popup');
//     if (!popup) return;

//     popup.style.display = 'none';
//     consentGiven = false;
//   }

//   function openPopup(button) {

//     consentGiven = false;

//     const popup = createPopup();
//     if (!popup) return;

//     const checkbox = popup.querySelector('#preorder-consent-check');
//     const confirmBtn = popup.querySelector('.preorder-continue');
//     const estimateTarget = popup.querySelector('.preorder-estimate');

//     checkbox.checked = false;
//     confirmBtn.disabled = true;

//     // 🔥 Grab directly from clicked button
//     const estimateText = getEstimateFromButton(button);
//     estimateTarget.textContent = estimateText || '';

//     popup.style.display = 'flex';

//     confirmBtn.onclick = function () {
//       consentGiven = true;
//       popup.style.display = 'none';
//       button.click();
//     };
//   }

//   document.addEventListener('click', function (e) {

//     const button = e.target.closest('button[type="submit"].is_inventory_preorder');
//     if (!button) return;

//     if (consentGiven) {
//       consentGiven = false;
//       return;
//     }

//     e.preventDefault();
//     e.stopImmediatePropagation();

//     openPopup(button);

//   }, true);

// })();

// Inline size picker quick shop mode:
// Shows size options directly on collection product cards and uses the theme cart pipeline.
(function () {
  const selectors = {
    card: '.product-grid-item--inline-size-picker',
    media: '[data-product-media-container]',
    form: '[data-inline-size-form]',
    picker: '[data-inline-size-picker]',
    trigger: '[data-inline-size-trigger]',
    option: '[data-inline-size-option]',
    close: '[data-inline-size-close]',
    variantInput: '[data-inline-size-variant-input]',
    preorderInput: '[data-inline-size-preorder-input]',
    swatchVariant: '[data-swatch-variant]',
  };

  const classes = {
    open: 'product-grid-item--inline-sizes-open',
  };

  // Viewport-width breakpoint (matches the CSS) — drives mobile bottom-sheet
  // vs desktop hover behavior. Switched from (hover: hover) so resizing a
  // desktop browser narrow gives the mobile experience as expected.
  const desktopQuery = window.matchMedia('(min-width: 768px)');

  function isEnabled() {
    return window.theme?.settings?.quickBuy === 'inline_size_picker';
  }

  function isDesktopHover() {
    return desktopQuery.matches;
  }

  function getCard(target) {
    if (!target) return null;
    const direct = target.closest?.(selectors.card);
    if (direct) return direct;
    // Picker may be portaled out to <body> on mobile; follow the back-reference.
    const picker = target.closest?.(selectors.picker);
    return picker?._owningCard || null;
  }

  function getForm(card) {
    return card?._portaledForm || card?.querySelector(selectors.form);
  }

  function getPicker(card) {
    return card?._portaledPicker || card?.querySelector(selectors.picker);
  }

  // Portal the whole form (which contains the picker) out to <body> on open so
  // it escapes every ancestor stacking context. We move the form — not just the
  // picker — because the theme's cartAddEvent listener does
  // `clickedElement.closest('form')` to build FormData. If the option button is
  // outside its form, the cart submit silently fails.
  function portalPicker(card) {
    if (!card) return;
    const form = card.querySelector(selectors.form);
    const picker = card.querySelector(selectors.picker);
    if (!form || form._isPortaled) return;

    form._owningCard = card;
    form._originalParent = form.parentNode;
    form._originalNextSibling = form.nextSibling;
    card._portaledForm = form;
    card._portaledPicker = picker;
    if (picker) picker._owningCard = card;

    ensurePortalContainer().appendChild(form);
    form._isPortaled = true;
    form.classList.add('is-quick-add-form-portaled');
  }

  function restorePicker(card) {
    if (!card) return;
    const form = card._portaledForm;
    if (!form || !form._isPortaled) return;

    if (form._originalParent) {
      form._originalParent.insertBefore(form, form._originalNextSibling || null);
    }
    form._isPortaled = false;
    form._owningCard = null;
    form._originalParent = null;
    form._originalNextSibling = null;
    form.classList.remove('is-quick-add-form-portaled');

    const picker = card._portaledPicker;
    if (picker) picker._owningCard = null;
    delete card._portaledForm;
    delete card._portaledPicker;
  }

  // Singleton container hosting the backdrop AND the portaled form, so quick-add
  // DOM is kept tidy under one root and shares a single high-z-index stacking
  // context that sits above the sticky header / pre-header etc.
  let portalContainerEl = null;
  let backdropEl = null;

  function ensurePortalContainer() {
    if (portalContainerEl) return portalContainerEl;

    portalContainerEl = document.createElement('div');
    portalContainerEl.className = 'quick-add-portal';
    document.body.appendChild(portalContainerEl);

    return portalContainerEl;
  }

  function ensureBackdrop() {
    if (backdropEl) return backdropEl;

    backdropEl = document.createElement('div');
    backdropEl.className = 'quick-add-backdrop';
    backdropEl.setAttribute('aria-hidden', 'true');
    backdropEl.addEventListener('click', () => closeOtherCards(null));

    ensurePortalContainer().appendChild(backdropEl);

    return backdropEl;
  }

  // One function = one truth. Showing the modal turns on the picker's active
  // class AND the body scroll lock atomically. Hiding turns BOTH off. They
  // cannot drift because they're always set together.
  function setPickerActive(picker, isActive) {
    if (!picker) return;
    if (isActive) {
      picker.classList.add('is-quick-add-active');
      ensureBackdrop();
      document.body.classList.add('quick-add-open');
    } else {
      picker.classList.remove('is-quick-add-active');
      document.body.classList.remove('quick-add-open');
    }
  }

  function closeCard(card) {
    if (!card) return;

    const picker = getPicker(card);
    const trigger = card.querySelector(selectors.trigger);

    card.classList.remove(classes.open);
    trigger?.setAttribute('aria-expanded', 'false');

    if (isDesktopHover()) {
      // Desktop: no animation, snap close.
      setPickerActive(picker, false);
      picker?.setAttribute('hidden', '');
      return;
    }

    // Mobile: swap the slide-up animation for the slide-down one, then unmount
    // after it ends. Keeping the form portaled during the close keeps all the
    // bottom-sheet styling (header, options, etc.) applied throughout.
    // setPickerActive(picker, false) releases the lock here — the backdrop
    // fades out in parallel with the slide-down.
    setPickerActive(picker, false);
    picker?.classList.add('is-quick-add-closing');

    const finalize = () => {
      picker?.classList.remove('is-quick-add-closing');
      picker?.setAttribute('hidden', '');
      restorePicker(card);
    };

    if (!picker) {
      finalize();
      return;
    }

    let done = false;
    const onAnimationEnd = (e) => {
      if (e.animationName !== 'quick-add-slide-down' || done) return;
      done = true;
      picker.removeEventListener('animationend', onAnimationEnd);
      finalize();
    };
    picker.addEventListener('animationend', onAnimationEnd);
    // Fallback in case animationend doesn't fire (reduced-motion, etc.).
    setTimeout(() => {
      if (done) return;
      done = true;
      picker.removeEventListener('animationend', onAnimationEnd);
      finalize();
    }, 350);
  }

  function closeOtherCards(activeCard) {
    document.querySelectorAll(`${selectors.card}.${classes.open}`).forEach((card) => {
      if (card !== activeCard) closeCard(card);
    });
  }

  function openCard(card) {
    if (!card) return;

    const trigger = card.querySelector(selectors.trigger);

    closeOtherCards(card);
    card.classList.add(classes.open);

    if (!isDesktopHover()) {
      portalPicker(card);
    }

    // Resolve picker AFTER portaling so we get the moved node.
    const picker = getPicker(card);
    picker?.removeAttribute('hidden');
    trigger?.setAttribute('aria-expanded', 'true');

    if (!isDesktopHover()) {
      // Clear any in-flight closing animation if reopening fast.
      picker?.classList.remove('is-quick-add-closing');
      setPickerActive(picker, true);
    }
  }

  function toggleCard(card) {
    if (!card) return;

    if (card.classList.contains(classes.open)) {
      closeCard(card);
    } else {
      openCard(card);
    }
  }

  function setPreorderInput(form, value) {
    const preorderInput = form?.querySelector(selectors.preorderInput);
    if (!preorderInput) return;

    if (value) {
      preorderInput.value = value;
      preorderInput.disabled = false;
    } else {
      preorderInput.value = '';
      preorderInput.disabled = true;
    }
  }

  function selectContext(card, selectedVariantId) {
    const selectedOption = card.querySelector(`${selectors.option}[data-variant-id="${selectedVariantId}"]`);
    if (!selectedOption) return;

    const contextKey = selectedOption.dataset.contextKey || '';
    const options = card.querySelectorAll(selectors.option);
    let firstVisibleOption = null;

    options.forEach((option) => {
      const isCurrentContext = (option.dataset.contextKey || '') === contextKey;
      option.hidden = !isCurrentContext;

      if (isCurrentContext && !firstVisibleOption) {
        firstVisibleOption = option;
      }
    });

    const variantInput = getForm(card)?.querySelector(selectors.variantInput);
    if (variantInput && firstVisibleOption) {
      variantInput.value = firstVisibleOption.dataset.variantId;
    }
  }

  document.addEventListener('mouseover', (event) => {
    if (!isEnabled() || !isDesktopHover()) return;

    const media = event.target.closest(selectors.media);
    const card = getCard(media);
    if (!card) return;

    openCard(card);
  });

  document.addEventListener('mouseout', (event) => {
    if (!isEnabled() || !isDesktopHover()) return;

    const media = event.target.closest(selectors.media);
    const card = getCard(media);
    if (!card) return;

    if (!media.contains(event.relatedTarget)) {
      closeCard(card);
    }
  });

  document.addEventListener('focusin', (event) => {
    if (!isEnabled() || !isDesktopHover()) return;

    const media = event.target.closest(selectors.media);
    const card = getCard(media);
    if (!card) return;

    openCard(card);
  });

  document.addEventListener('focusout', (event) => {
    if (!isEnabled() || !isDesktopHover()) return;

    const media = event.target.closest(selectors.media);
    const card = getCard(media);
    if (!card) return;

    window.setTimeout(() => {
      if (!media.contains(document.activeElement)) {
        closeCard(card);
      }
    });
  });

  document.addEventListener('click', (event) => {
    if (!isEnabled()) return;

    const swatch = event.target.closest(selectors.swatchVariant);
    if (swatch) {
      const card = getCard(swatch);
      const selectedVariantId = swatch.dataset.swatchVariant || swatch.getAttribute('data-swatch-variant');
      if (card && selectedVariantId) selectContext(card, selectedVariantId);
      return;
    }

    const close = event.target.closest(selectors.close);
    if (close) {
      event.preventDefault();
      closeCard(getCard(close));
      return;
    }

    const trigger = event.target.closest(selectors.trigger);
    if (trigger) {
      event.preventDefault();
      if (!isDesktopHover()) toggleCard(getCard(trigger));
      return;
    }

    const option = event.target.closest(selectors.option);
    if (option) {
      event.preventDefault();

      if (option.disabled || option.getAttribute('aria-disabled') === 'true') return;

      const card = getCard(option);
      const form = getForm(card);
      const variantInput = form?.querySelector(selectors.variantInput);

      if (!card || !form || !variantInput || !option.dataset.variantId) return;

      variantInput.value = option.dataset.variantId;
      setPreorderInput(form, option.dataset.preorderProperty || '');

      document.dispatchEvent(
        new CustomEvent('theme:cart:add', {
          detail: {
            button: option,
          },
        })
      );

      return;
    }

    if (!isDesktopHover() && !event.target.closest(selectors.picker)) {
      closeOtherCards(null);
    }
  });

  // Resize from mobile → desktop while the bottom-sheet is open would leave the
  // page in a "frozen" state (body scroll locked, form still portaled, picker
  // fixed at the viewport bottom). Snap everything closed on the breakpoint flip.
  desktopQuery.addEventListener('change', (event) => {
    if (!event.matches) return;
    document.querySelectorAll(`${selectors.card}.${classes.open}`).forEach((card) => {
      const picker = getPicker(card);
      const trigger = card.querySelector(selectors.trigger);
      card.classList.remove(classes.open);
      setPickerActive(picker, false);
      picker?.classList.remove('is-quick-add-closing');
      picker?.setAttribute('hidden', '');
      trigger?.setAttribute('aria-expanded', 'false');
      restorePicker(card);
    });
  });
})();


// Bypass the theme's GridSwatch click hijack on product-card color swatches.
// The theme calls event.preventDefault() on mouse clicks to swap the card image
// in-place; we want the link to behave like a link. Capture-phase +
// stopImmediatePropagation stops the theme's bubble-phase listener from running,
// so native navigation proceeds.
(function () {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.swatch__link');
    if (!link) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.stopImmediatePropagation();
  }, true);
})();

// ============================================================================
// Gift With Purchase (GWP) - auto-add the merchant-selected gift variant when
// cart total crosses the market threshold. Config comes from .cart-message
// (emitted by snippets/cart-progress.liquid). Cart state comes from the same
// DOM attributes the theme's own progress-updater reads (theme.dev.js:3743) -
// no /cart.js fetch needed.
//
// Hook: theme:cart:added is the theme's universal post-mutation event (fires
// after Section Rendering has written fresh [data-cart-total]). We ignore
// theme:cart:add and theme:cart:update - those fire pre-mutation with stale
// state.
//
// After we auto-add via POST /cart/add.js we dispatch theme:cart:refresh so
// the theme re-syncs its drawer/cart page (theme.dev.js:2603 hook). That
// re-fires theme:cart:added, which re-enters evaluate() - the variant-ID
// guard catches it as "already in cart" and stops the loop.
//
// Kill switch: window.GWP.debug = false silences logs. Set at top of file.
// ============================================================================
window.GWP = window.GWP || { debug: true };

(function () {
  const TAG = '[GWP]';
  const log = (...args) => { if (window.GWP.debug) console.log(TAG, ...args); };

  function readConfig() {
    const el = document.querySelector('.cart-message[data-gwp-variant-id]');
    if (!el) return null;
    const thresholdDollars = parseInt(el.dataset.giftLimit, 10);
    const variantId = String(el.dataset.gwpVariantId || '');
    if (!thresholdDollars || !variantId) return null;
    return { thresholdCents: thresholdDollars * 100, variantId };
  }

  function readCartTotalCents() {
    const el = document.querySelector('[data-cart-total]');
    if (!el) return null;
    const n = parseInt(el.getAttribute('data-cart-total'), 10);
    return Number.isFinite(n) ? n : null;
  }

  // data-item on cart lines is "<variantId>:<key>". Return how much to
  // subtract from cart total to derive paidSubtotal for the gift line, or
  // null if the gift isn't in the cart. Capped at one unit's original price
  // so extra gift quantities (qty >= 2) count as normal paid spend and only
  // the single free unit is excluded from the threshold calculation.
  function readGiftLineCents(variantId) {
    const line = document.querySelector('[data-cart-item][data-item^="' + variantId + ':"]');
    if (!line) return null;
    const linePrice = parseInt(line.getAttribute('data-line-price'), 10);
    const unitPrice = parseInt(line.getAttribute('data-unit-original-price'), 10);
    const safeLine = Number.isFinite(linePrice) ? linePrice : 0;
    const safeUnit = Number.isFinite(unitPrice) ? unitPrice : safeLine;
    return Math.min(safeLine, safeUnit);
  }

  // Format cents the way the theme's shipping-side updateProgress does
  // (theme.dev.js:3968-3979): use window.theme.formatMoney, strip trailing
  // .00/,00, and append the ISO code if the theme setting is on.
  function formatCents(cents) {
    const t = window.theme || {};
    const fmt = t.moneyFormat || t.money_format;
    if (t.formatMoney && fmt) {
      let text = t.formatMoney(cents, fmt);
      if (text.endsWith('.00') || text.endsWith(',00')) text = text.slice(0, -3);
      if (t.settings && t.settings.currency_code_enable && t.current_iso_code) {
        text += ' ' + t.current_iso_code;
      }
      return text;
    }
    return String(Math.round(cents / 100));
  }

  // The theme's Section Rendering only refreshes the items holder, not the
  // .cart-message wrapper - so is-shipping-met/is-all-met, the gift-progress
  // bar, and the gift-left-to-spend text set by Liquid on initial page load
  // all go stale on every mutation. We compute against paid subtotal (cart
  // total minus the gift line's current price) so the calculation matches
  // what the customer has actually spent on qualifying items. is-success
  // and is-hidden remain the theme's concern.
  function syncMessage(paidSubtotalCents) {
    document.querySelectorAll('.cart-message[data-gwp-variant-id]').forEach((msg) => {
      const shippingCents = parseInt(msg.dataset.limit, 10) * 100;
      const giftCents = parseInt(msg.dataset.giftLimit, 10) * 100;

      msg.classList.toggle('is-all-met', paidSubtotalCents >= giftCents);
      msg.classList.toggle('is-shipping-met', paidSubtotalCents >= shippingCents && paidSubtotalCents < giftCents);

      // Gift progress bar - mirrors cart-progress.liquid gift_percent math.
      const giftSpan = giftCents - shippingCents;
      let giftPercent = 0;
      if (giftSpan > 0 && paidSubtotalCents > shippingCents) {
        giftPercent = ((paidSubtotalCents - shippingCents) / giftSpan) * 100;
        if (giftPercent > 100) giftPercent = 100;
      }
      msg.querySelectorAll('[data-gift-progress]').forEach((el) => {
        el.setAttribute('value', giftPercent);
        el.style.setProperty('--progress-width', giftPercent + '%');
      });

      // Gift left-to-spend text (only visible in is-shipping-met state).
      // Ceil to nearest whole currency unit so sub-dollar slivers from
      // tax/rounding ($0.03) don't render as "spend $0.03 more".
      const giftLeftEl = msg.querySelector('[data-gift-left-to-spend]');
      if (giftLeftEl) {
        const remaining = Math.max(giftCents - paidSubtotalCents, 0);
        const remainingCeil = Math.ceil(remaining / 100) * 100;
        giftLeftEl.textContent = formatCents(remainingCeil);
      }
    });
  }

  let addInFlight = false;

  async function evaluate(trigger) {
    const cfg = readConfig();
    if (!cfg) { log(trigger, '- no config on page'); return; }

    const cartTotal = readCartTotalCents();
    if (cartTotal == null) { log(trigger, '- no [data-cart-total] on page'); return; }

    const giftLineCents = readGiftLineCents(cfg.variantId);
    const giftInCart = giftLineCents !== null;
    const paidSubtotal = cartTotal - (giftInCart ? giftLineCents : 0);
    const eligible = paidSubtotal >= cfg.thresholdCents;
    syncMessage(paidSubtotal);
    log(trigger, { cartTotal, giftLineCents, paidSubtotal, threshold: cfg.thresholdCents, giftInCart, eligible });

    if (giftInCart) return;         // already there
    if (!eligible) return;          // under threshold
    if (addInFlight) { log(trigger, '- add already in flight, skipping'); return; }

    addInFlight = true;
    try {
      log(trigger, '- auto-adding gift variant', cfg.variantId);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(cfg.variantId, 10),
            quantity: 1,
            properties: { _free_gift_auto_added: 'true' },
          }],
        }),
      });
      if (!res.ok) throw new Error('add failed: ' + res.status);
      log(trigger, '- added, dispatching theme:cart:refresh');
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    } catch (e) {
      log(trigger, '- add error', e);
    } finally {
      addInFlight = false;
    }
  }

  document.addEventListener('theme:cart:added', () => evaluate('theme:cart:added'));
  document.addEventListener('theme:cart:loaded', () => evaluate('theme:cart:loaded'));

  // /cart page: progress bar is in the initial DOM, so evaluate immediately.
  // Non-cart pages: no [data-cart-total] at init; evaluate() will bail and
  // theme:cart:loaded picks up once the drawer template renders.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => evaluate('init'));
  } else {
    evaluate('init');
  }

  log('installed');
})();

// ============================================================================
// Cart-drawer scroll-lock guard - workaround for third-party interference
// ============================================================================
// The Size Charts by Relentless app extension binds a jQuery click handler on
// <body> that runs a closeModal routine on every bubbled click. That routine
// unconditionally clears document.body.style.overflow, even when its own modal
// isn't open. On product pages (where the extension is loaded), clicking the
// cart drawer's qty +/- buttons bubbles up to body and strips overflow:hidden,
// leaving the theme's padding-right:15px in place. Result: the page behind the
// drawer becomes scrollable while the drawer is still open.
//
// While the cart drawer is open (body.classList.contains('js-drawer-open-cart')),
// re-assert overflow:hidden whenever anything else clears it. Once the drawer
// closes and the class comes off, we stop touching body so the theme's own
// scroll-lock cleanup runs untouched.
(function () {
  const OPEN_CLASS = 'js-drawer-open-cart';
  const observer = new MutationObserver(() => {
    if (!document.body.classList.contains(OPEN_CLASS)) return;
    if (document.body.style.overflow !== 'hidden') {
      document.body.style.overflow = 'hidden';
    }
  });
  observer.observe(document.body, { attributes: true, attributeFilter: ['style'] });
})();
